const { templates } = require('./templates')
const { regexes } = require('./regex')
const substituteEncodedCarets = require('./substituteEncodedCarets')

function substituteEncodedCharacters (text, mode) {
  if (!text || !mode) return

  const template = templates[mode]
  const regex = regexes[mode]
  const styles = Object.keys(regex)
  let i = styles.length

  // we only encode '<' once to avoid mangling valid XML as it is built up
  if (mode !== 'PROSE_TO_FDX') text = substituteEncodedCarets(text)

  // temporarily replace escaped _ and *
  text = text.replace(/\\\*/g, '[star]').replace(/\\_/g, '[underline]').replace(/\\\+/g, '[plus]')

  while (i--) {
    const re = regex[styles[i]]
    if (re.test(text)) {
      text = text.replace(re, template[styles[i]])
    }
  }

  return text.replace(/\[star\]/g, '*').replace(/\[underline\]/g, '_').replace(/\[plus\]/g, '+')
}

module.exports = substituteEncodedCharacters
